import styled from "@emotion/styled";

export const Text = styled.div`
  padding: 0 16px 16px 16px;
  font-size: 16px;
`;
export const ModalContent = styled.div`
  text-align: center;
  width: 100%;
`;
